import { render, staticRenderFns } from "./RootContrattiProvvisoriView.vue?vue&type=template&id=28215882&"
import script from "./RootContrattiProvvisoriView.vue?vue&type=script&lang=ts&"
export * from "./RootContrattiProvvisoriView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports